import { Logo } from "@components";
import { FC, PropsWithChildren, useCallback } from "react";

export const AuthWrapper: FC<PropsWithChildren> = ({ children }) => {
    const renderLogoContainer = useCallback(() => (
        <div className="hidden lg:flex flex-1 items-center justify-center">
            <Logo size={400} />
        </div>
    ), []);

    return (
        <div className="flex h-screen bg-primary">
            {renderLogoContainer()}
            <div
                className="flex flex-col overflow-hidden 
             justify-center bg-base-100 w-full lg:w-2/5 rounded-none 
             lg:rounded-l-3xl p-8 shadow-lg"
            >
                {children}
            </div>
        </div>
    )
}
